import styled from 'styled-components';

export const Ftr = styled.div`
    width: 100%;
    background: black;
`;

export const FooterContainer = styled.div`
    max-width:1000px;
    margin: auto;
    height:100%;
    display:flex;
    align-items:flex-start;
    justify-content: space-between;


    @media screen and (max-width: 1200px){
        display:flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
`;

export const Caption = styled.div`
      margin-top: 10px;
      color: white;
      font-size: 15px;
      font-weight: 300;
      text-transform: uppercase;
      font-family: 'Open Sans', sans-serif;

      @media screen and (max-width: 1200px){
      margin-top: 20px;
      color: white;
      font-size: 15px;
      font-weight: 300;
      text-transform: uppercase;
      }
`;

export const CaptionSocial = styled.div`
      margin-top: 10px;
      margin-bottom: 20px;
      font-size: 25px;

      a{
        margin-left:15px;
      }

      @media screen and (max-width: 1200px){
        margin-bottom: 10px;
      a{
        margin:10px;
      }
      }
`;
